import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { IPremium } from '../interfaces/premium';
import { IPremiumFilter } from '../interfaces/premium-filter';
import { EditService } from './edit.service';
import { HttpResponsesHandlersFactory } from '../handlers/http-responses-handler';

@Injectable({ providedIn: 'root' })
export class PremiumService extends EditService<IPremium, IPremiumFilter> {
  url = '/api/premiums';
  entityTitle = 'Premiums';

  constructor(http: HttpClient, handlersFactory: HttpResponsesHandlersFactory) {
    super(http, handlersFactory);
  }

  save(data: any): Promise<any> {
    let successMsg =
      typeof data.id != undefined && data.id != 0 ? 'Premiums updated.' : 'Premiums added.';

    return this.handleRequest(
      this.http.post(`${this.url}` + '/save', data),
      this.handlersFactory.getForUpdate(this.entityTitle),
      successMsg,
    );
  }
}
